import Vue from 'vue'
import VueRouter from 'vue-router'
import { routers } from './route'

Vue.use(VueRouter)

const routerConfig = {
  mode: 'history',
  linkActiveClass: 'active',
  routes: routers,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
}

const router = new VueRouter(routerConfig)

export default router
